import React, { useState, useRef } from 'react';

const keyframes = `
  @keyframes shIconGlow {
    0%,100% { filter: drop-shadow(0 0 2px rgba(0,245,160,0.4)); }
    50%      { filter: drop-shadow(0 0 7px rgba(0,245,160,0.9)); }
  }
  @keyframes shSlideUp {
    from { opacity: 0; transform: translateY(10px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes shSlideOut {
    from { opacity: 1; transform: translateY(0); }
    to   { opacity: 0; transform: translateY(-10px); }
  }
`;

const CatIcons = {
  admin:         (c) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18M4 21V8l8-5 8 5v13"/><path d="M9 21v-6h6v6"/></svg>,
  finance:       (c) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18M5 21V11l7-7 7 7v10"/><path d="M10 16v-3h4v3"/><line x1="12" y1="4" x2="12" y2="11"/></svg>,
  pro:           (c) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/><line x1="12" y1="12" x2="12" y2="16"/><line x1="10" y1="14" x2="14" y2="14"/></svg>,
  security:      (c) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/><circle cx="12" cy="16" r="1"/></svg>,
  storage:       (c) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M18 10h-1.26A8 8 0 109 20h9a5 5 0 000-10z"/></svg>,
  communication: (c) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><polyline points="2,4 12,13 22,4"/></svg>,
  social:        (c) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill={c}/></svg>,
  ecommerce:     (c) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 001.96-1.61L23 6H6"/></svg>,
  gaming:        (c) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="12" rx="4"/><line x1="9" y1="12" x2="13" y2="12"/><line x1="11" y1="10" x2="11" y2="14"/><line x1="16" y1="11" x2="16" y2="11"/><line x1="18" y1="13" x2="18" y2="13"/></svg>,
  misc:          (c) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/></svg>,
};

const CheckSvg = () => (
  <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="#0A1628" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const CATEGORIES = [
  { id: 'admin',         label: 'Administratif & légal',    short: 'Administratif',  },
  { id: 'finance',       label: 'Finance',                  short: 'Finance',        },
  { id: 'pro',           label: 'Pro & business',           short: 'Pro & business', },
  { id: 'security',      label: 'Sécurité & accès',         short: 'Sécurité',       },
  { id: 'storage',       label: 'Stockage & données',       short: 'Stockage',       },
  { id: 'communication', label: 'Communication',            short: 'Communication',  },
  { id: 'social',        label: 'Réseaux sociaux',          short: 'Réseaux sociaux',},
  { id: 'ecommerce',     label: 'E-commerce & abonnements', short: 'E-commerce',     },
  { id: 'gaming',        label: 'Gaming & loisirs',         short: 'Gaming',         },
  { id: 'misc',          label: 'Divers',                   short: 'Divers',         },
];

const SUBTYPES = {
  admin:         ['Ameli / Sécurité sociale', 'Impots.gouv', 'CAF / MSA', 'France Connect', 'Retraite (CNAV…)', 'Espace notaire', 'Digiposte'],
  finance:       ['Compte bancaire courant', "Compte d'épargne / livret", 'Portefeuille crypto / NFT', 'Trading / bourse / ETF', 'Assurance vie', 'PayPal / Revolut / Lydia'],
  pro:           ['Nom de domaine / hébergement', 'Freelance (Malt, Upwork…)', 'Comptabilité (Qonto, Pennylane)', 'Outils SaaS (Notion, Slack…)', 'Signature électronique'],
  security:      ['Gestionnaire de mots de passe', 'Authentification 2FA', 'VPN / accès distant', 'Certificat numérique'],
  storage:       ['Google Drive / OneDrive', 'Dropbox / iCloud', 'Photos / galerie cloud', 'Sauvegarde téléphone', 'NAS / serveur perso'],
  communication: ['Boîte email principale', 'Boîte email secondaire', 'WhatsApp / Telegram', 'Signal / iMessage', 'SMS / contacts'],
  social:        ['Facebook / Instagram', 'Twitter / X', 'TikTok / Snapchat', 'YouTube / Twitch', 'Pinterest / Reddit'],
  ecommerce:     ['Amazon / eBay', 'Vinted / Leboncoin', 'Netflix / Disney+', 'Spotify / Deezer', 'Abonnements SaaS', 'Adobe / Microsoft 365'],
  gaming:        ['Steam / Epic Games', 'PlayStation Network', 'Xbox / Microsoft', 'Collections numériques', 'Jeux mobile'],
  misc:          ['Licences logiciels', 'Codes PIN numérisés', 'Abonnements divers', 'Autre'],
};

const AccountCategoryPicker = ({
  category = null,
  subType = null,
  onCategory,
  onSubType,
}) => {
  const [activeCat, setActiveCat]         = useState(category);
  const [activeSubType, setActiveSubType] = useState(subType);
  const [panelOpen, setPanelOpen]         = useState(false);
  const [closing, setClosing]             = useState(false);
  const timerRef = useRef(null);

  const handleCat = (id) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setActiveCat(id);
    setActiveSubType(null);
    setClosing(false);
    setPanelOpen(true);
    onCategory && onCategory(id);
    onSubType && onSubType(null);
  };

  const handleSub = (label) => {
    setClosing(true);
    timerRef.current = setTimeout(() => {
      setPanelOpen(false);
      setClosing(false);
    }, 180);
    setActiveSubType(label);
    onSubType && onSubType(label);
  };

  const clearSub = () => {
    setActiveSubType(null);
    setPanelOpen(false);
    onSubType && onSubType(null);
  };

  const activeCatData = CATEGORIES.find(c => c.id === activeCat);

  return (
    <>
      <style>
        {`
          ${keyframes}
          .sh-cat-icon { animation: shIconGlow 3.5s ease-in-out infinite; }
          .sh-cc:hover  { border-color: rgba(255,255,255,0.22) !important; }
          .sh-cc.sh-on  { border-color: rgba(0,245,160,0.55) !important; }
          .sh-cc.sh-on .sh-cc-lbl { color: #fff !important; }
          .sh-cc.sh-on .sh-ck     { opacity: 1 !important; }
          .sh-sub-item:hover       { border-color: rgba(255,255,255,0.2) !important; color: #fff !important; }
        `}
      </style>

      {/* Grille catégories */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: '6px' }}>
        {CATEGORIES.map((cat, i) => (
          <div
            key={cat.id}
            className={`sh-cc${activeCat === cat.id ? ' sh-on' : ''}`}
            onClick={() => handleCat(cat.id)}
            style={{
              position: 'relative',
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '9px',
              padding: '9px 7px 8px',
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '5px',
              transition: 'border-color 0.15s',
            }}
          >
            <div className="sh-ck" style={{
              position: 'absolute', top: '6px', right: '6px',
              width: '12px', height: '12px', borderRadius: '50%',
              background: '#00F5A0', display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              opacity: 0, transition: 'opacity 0.2s',
            }}>
              <CheckSvg />
            </div>
            <span className="sh-cat-icon" style={{ animationDelay: `${i * 0.08}s` }}>
              {CatIcons[cat.id]?.('#00F5A0')}
            </span>
            <p className="sh-cc-lbl" style={{ color: '#8892A4', fontSize: '10px', lineHeight: 1.25, margin: 0, transition: 'color 0.15s' }}>
              {cat.short}
            </p>
          </div>
        ))}
      </div>

      {/* Badge sous-type sélectionné */}
      {activeSubType && (
        <div style={{
          display: 'flex', alignItems: 'center', gap: '6px',
          marginTop: '8px', padding: '4px 10px',
          background: 'rgba(0,245,160,0.08)',
          border: '1px solid rgba(0,245,160,0.25)',
          borderRadius: '20px', width: 'fit-content',
        }}>
          <span style={{ color: '#00F5A0', fontSize: '11px' }}>{activeSubType}</span>
          <button onClick={clearSub} style={{ background: 'none', border: 'none', color: '#8892A4', cursor: 'pointer', fontSize: '13px', lineHeight: 1, padding: '0 0 0 2px' }}>✕</button>
        </div>
      )}

      {panelOpen && activeCatData && (
          <div style={{
            marginTop: 8,
            background: '#0A1628',
            border: '1px solid rgba(0,245,160,0.25)',
            borderRadius: '10px',
            padding: '14px 16px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
            animation: closing ? 'shSlideOut 0.18s ease forwards' : 'shSlideUp 0.2s ease',
          }}>
            <p style={{ color: '#00F5A0', fontSize: '11px', fontWeight: 500, marginBottom: '10px' }}>
              {activeCatData.label}
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px' }}>
              {SUBTYPES[activeCat].map((sub) => (
                <div
                  key={sub}
                  className="sh-sub-item"
                  onClick={() => handleSub(sub)}
                  style={{
                    background: '#111e35',
                    border: '1px solid rgba(255,255,255,0.08)',
                    borderRadius: '8px',
                    padding: '8px 12px',
                    cursor: 'pointer',
                    color: '#8892A4',
                    fontSize: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    transition: 'border-color 0.15s, color 0.15s',
                  }}
                >
                  <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: 'rgba(255,255,255,0.2)', flexShrink: 0 }} />
                  {sub}
                </div>
              ))}
            </div>
          </div>
      )}
    </>
  );
};

export { CATEGORIES, SUBTYPES };
export default AccountCategoryPicker;
